import React from 'react';
import { connect } from 'react-redux';
import { Dialog, FontIcon } from 'material-ui';
import CreateTemplateGroup from './create-group-wizard';

const CreateGroupDialog = ({ createTemplateGroupOpen, updateProps, groupCreated, getTemplates }) => (
  <Dialog
    titleStyle={{ padding: '12px 24px' }}
    onRequestClose={() => updateProps({ createTemplateGroupOpen: false })}
    title={groupCreated ? (
      <div style={{ backgroundColor: '#00bcd4', color: 'white', fontSize: '20px', textAlign: 'center' }}>
        Create Template Group
      </div>
    ) : (<div style={{ backgroundColor: '#00bcd4', color: 'white', fontSize: '20px', display: 'flex', justifyContent: 'space-between' }}>
      Create Template Group
      <FontIcon
        className="tc-icon-close"
        style={{ cursor: 'pointer', color: 'white', fontSize: '24px', top: '4px' }}
        onTouchTap={() => updateProps({ createTemplateGroupOpen: false })}
      />
    </div>)}
    autoScrollBodyContent
    contentStyle={{ transform: 'none' }}
    style={{ transform: 'none' }}
    open={createTemplateGroupOpen}
  >
    <CreateTemplateGroup
      afterCreationFn={() => {
        updateProps({ createTemplateGroupOpen: false, showType: 'group' });
        getTemplates();
      }}
    />
  </Dialog>);
const mapStateToProps = ({ contracting }) => ({
  createTemplateGroupOpen: contracting.templateList.get('createTemplateGroupOpen'),
  groupCreated: contracting.templateList.get('groupCreated'),
});
export default connect(mapStateToProps)(CreateGroupDialog);



// WEBPACK FOOTER //
// ./src/app/components/contracting/template-list/create-group/create-group-dialog.jsx